module.exports = __webpack_public_path__ + "img/category-fishing-game.67895065.png";